import gql from 'graphql-tag'

import { responsiveImageFragment } from '../fragments/images.js'
import { seoFragment } from '../fragments/seo.js'
import { sectionFragment, slimBannerFragment, textImageBlockFragment, zoomMasonryFragment } from '../fragments/body.js'
import { heroFragment } from '../fragments/hero.js'

export const getCiders = gql`
  ${responsiveImageFragment}
  ${seoFragment}
  ${heroFragment}
  ${zoomMasonryFragment}
  ${slimBannerFragment}
  ${sectionFragment}
  ${textImageBlockFragment}
  query getCiders($locale: SiteLocale) {
    allProducts(locale: $locale) {
      id
      name
      slug
      listingImage {
        id
        responsiveImage(imgixParams: { auto: compress, q: "60" }) {
          ...ResponsiveImageFragment
        }
      }
      listingExtract
      listingCtaLabel
    }
    cidersPage(locale: $locale) {
      seo {
        ...SeoFragment
      }
      hero {
        ...HeroFragment
      }
      body {
        __typename
        ... on ZoomMasonryRecord {
          ...ZoomMasonryFragment
        }
        ... on SlimBannerRecord {
          ...SlimBannerFragment
        }
        ... on SectionRecord {
          ...SectionFragment
        }
        ... on TextImageBlockRecord {
          ...TextImageBlockFragment
        }
      }
    }
  }
`
